import { Component } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Router } from "@angular/router";
import { ZipCodeValidator } from "@centiro/zipcode-validator";
import * as LocaleList from "@centiro/locale-list";
import { clientConfig } from "../../../shared/constant/app.constant";
import { AppFlowService } from "../../../shared/services/app-flow/app-flow.service";
import { updateOrderAddressFromReturnOrderAction } from "../../../store/actions/order.actions";

@Component({
  selector: "update-address",
  templateUrl: "update-address.component.html",
  styleUrls: ["./update-address.component.scss"],
})
export class UpdateAddressComponent {
  countries = [];
  country: string;
  countryName: string;
  returnOrder: any;
  orderAddress: any;
  cancelButton: boolean;
  showerror = false;
  zipCodeValidation: boolean = true;
  addressinfo: AddressInfo = {};
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  };

  backBtnUrl = {
    routeUrl: "",
  };
  emailInputReadonly:boolean

  //ngOnInit() {}

  constructor(private router: Router, private store: Store<AppState>, private appFlowService: AppFlowService) {
    if (clientConfig.COUNTRIESALLOWED) {
      const countriesList = clientConfig.COUNTRIESALLOWED;
      for (let i = 0; countriesList && i < countriesList.length; i++) {
        const id = countriesList[i];
        let name;
        const locale = LocaleList.getByCountryCode(countriesList[i])[0];
        if (locale) {
            name = locale.location;
        }
        if (id && name) {
            const countryData = {
                id: id,
                name: name,
            };
            this.countries.push(countryData);
        }
      }
    }
    this.returnOrder = this.store.pipe(select("returnOrder"));
    this.backBtnUrl.routeUrl = "/m/shippingoption";
    this.appFlowService.activeStepId = 2;
    this.returnOrder.subscribe((ro) => {
      this.orderAddress = ro.orderAddress;
      this.addressinfo.name = ro.orderAddress.name;
      this.addressinfo.state = ro.orderAddress.state;
      this.addressinfo.additionalAddressInformation = ro.orderAddress.additionalAddressInformation;
      this.addressinfo.city = ro.orderAddress.city;
      this.addressinfo.street = ro.orderAddress.streetAddress;
      this.addressinfo.zipcode = ro.orderAddress.zipcode;
      this.addressinfo.email = ro.orderAddress.contactInfo.email;
      this.country = ro.orderAddress.isoCountry;
      if (!this.countries || this.countries.length === 0) {
        this.countries = [];
        this.countries.push({
          id: ro.orderAddress.isoCountry,
          name: LocaleList.getByCountryCode(ro.orderAddress.isoCountry)[0].location,
        });
      }

      if (
        ro.orderAddress.isoCountry === "" ||
        ro.orderAddress.city === "" ||
        ro.orderAddress.streetAddress === "" ||
        ro.orderAddress.name === ""
      ) {
        this.cancelButton = false;
        this.showerror = true;
      } else if (
        ro.orderAddress.isoCountry === undefined ||
        ro.orderAddress.city === undefined ||
        ro.orderAddress.streetAddress === undefined ||
        ro.orderAddress.name === undefined
      ) {
        this.cancelButton = false;
        this.showerror = true;
      } else {
        this.cancelButton = true;
        this.showerror = false;
      }
    });
    this.countryName = this.countries.filter((x) => x.id === this.country)[0].name;
    this.emailInputReadonly=this.orderAddress.contactInfo.email === "" || this.orderAddress.contactInfo.email === undefined?false:true;
  }
  selectCountry(event) {
    this.country = event.target.value;
    this.countryName = this.countries.filter((x) => x.id === event.target.value)[0].name;
  }

  saveAddress() {
    let latitude = this.orderAddress.latitude;
    let longitude = this.orderAddress.longitude;
    const firstName = this.orderAddress.contactInfo.firstName;
    const lastName = this.orderAddress.contactInfo.lastName;
    const phone = this.orderAddress.contactInfo.phone;

    if (this.AddressChanged()) {
      latitude = null;
      longitude = null;
    }
    this.store.dispatch(
      updateOrderAddressFromReturnOrderAction({
        payload: {
          name: this.addressinfo.name,
          city: this.addressinfo.city,
          state: this.addressinfo.state,
          streetAddress: this.addressinfo.street,
          zipcode: this.addressinfo.zipcode,
          additionalAddressInformation: this.addressinfo.additionalAddressInformation,
          isoCountry: this.country,
          latitude: latitude,
          longitude: longitude,
          contactInfo: {
            firstName: firstName,
            lastName: lastName,
            email: this.addressinfo.email,
            phone: phone,
          }
        }
      })
    );

    this.zipCodeValidation = true;
    if (this.addressinfo.zipcode)
      this.zipCodeValidation = ZipCodeValidator.isValid(this.addressinfo.zipcode, this.country);

    if (
      this.addressinfo.name &&
      this.addressinfo.city &&
      this.addressinfo.street &&
      this.country &&
      this.zipCodeValidation &&
      this.validateEmail(this.addressinfo.email)
    ) {
      this.showerror = false;
      this.router.navigate(["/m/shippingoption"]);
    } else {
      this.addressinfo.name = this.orderAddress.name;
      this.addressinfo.city = this.orderAddress.city;
      this.addressinfo.street = this.orderAddress.streetAddress;
      this.addressinfo.zipcode = this.orderAddress.zipcode;
      this.addressinfo.email = this.orderAddress.contactInfo.email;
      this.country = this.orderAddress.isoCountry;
      this.showerror = true;
      this.cancelButton = false;
    }
  }
  AddressChanged() {
    if (
      this.orderAddress.city !== this.addressinfo.city ||
      this.orderAddress.state !== this.addressinfo.state ||
      this.orderAddress.streetAddress !== this.addressinfo.street ||
      this.orderAddress.zipcode !== this.addressinfo.zipcode ||
      this.orderAddress.contactInfo.email !== this.addressinfo.email
    )
      return true;

    return false;
  }

  validateEmail(email: string): boolean {
    if(email === "" || email === undefined)
      {
        return true;
      }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
}
